export default __webpack_public_path__ + "static/media/vista-floor-plans.21b50542.pdf";